import { ReactElement } from 'react';
import { FormListFieldData, FormListOperation } from 'antd/es/form';
import { BaseBlock } from '../../../../../components/styles/Block';
import { RowsLayout } from './TableRows.style';
import Row from './Row';
import { BulkCreateCustomersResponse } from '@minutes-system/backend/src/api/customers/schema';

interface Props {
  fields: FormListFieldData[];
  onRemove: FormListOperation['remove'];
  minRows: number;
  results: BulkCreateCustomersResponse | null;
}

const TableRows = ({ fields, onRemove, minRows, results }: Props): ReactElement => (
  <BaseBlock>
    <RowsLayout>
      {fields.map(field => {
        const matchedResult = results?.results.find(r => r.rowKey === field.key);

        return (
          <Row
            key={field.key}
            fieldName={field.name}
            onRemove={() => {
              onRemove(field.name);
            }}
            canRemove={fields.length > minRows}
            result={matchedResult}
            rowKey={field.key}
          />
        );
      })}
    </RowsLayout>
  </BaseBlock>
);

export default TableRows;
